module.exports = __webpack_public_path__ + "img/510568a.png";